import {
  ButtonGroup,
  List,
  ListItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
  Link,
} from "@certn/cascadia-react";
import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

export function PrimaryInfoModal() {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          textStyle="global/body-secondary"
          textColor="text-weak"
          testID="npc-identification-documents-primary-document-whats-this-button"
        >
          <Trans>What's this?</Trans>
        </Link>
      )}
    >
      {(close) => (
        <LegacyModal>
          <ModalHeader close={close} title={t("Primary document")} />
          <ModalContent>
            <Text style="global/body-primary">
              <Trans>The following primary documents are accepted:</Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Foreign Passport (current)
                  </strong>{" "}
                  - name and photo required - 70 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian Passport (current or expired within last 2 years
                    but not cancelled)
                  </strong>{" "}
                  - name and photo required - 70 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian Citizenship Certificate
                  </strong>{" "}
                  - name required - 70 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Full Birth certificate (not birth certificate extract)
                  </strong>{" "}
                  - name required - 70 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Certificate of Identity issued by the Australian Government
                    to refugees and non Australian citizens for entry to
                    Australia
                  </strong>{" "}
                  - name required - 70 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian Driver Licence/Learner's Permit
                  </strong>{" "}
                  - name, address, and photo required - 40 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Current (Australian) Tertiary Student Identification Card
                  </strong>{" "}
                  - name and photo required - 40 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Photo identification card issued for Australian regulatory
                    purposes (e.g. Aviation/Maritime Security identification,
                    security industry etc.)
                  </strong>{" "}
                  - name and photo required - 40 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Government employee ID (Australian Federal/State/Territory)
                  </strong>{" "}
                  - name and photo required - 40 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Defence Force Identity Card (with photo or signature)
                  </strong>{" "}
                  - name and photo required - 40 points
                </Trans>
              </ListItem>
            </List>
          </ModalContent>
          <ModalFooter>
            <ButtonGroup>
              <PrimaryButton onPress={close} size="medium">
                <Trans>Okay</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
